// Tiny IndexedDB wrapper for offline time-entry queue + cache.
const DB_NAME = "crewtime-db";
const DB_VERSION = 5;
const STORES = ["pending_entries", "cache", "pending_observations", "pending_photos", "pending_form_scans", "pending_irrigation_logs"];

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      STORES.forEach((s) => {
        if (!db.objectStoreNames.contains(s)) db.createObjectStore(s, { keyPath: "id" });
      });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(store, mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const s = t.objectStore(store);
    const out = fn(s);
    t.oncomplete = () => resolve(out);
    t.onerror = () => reject(t.error);
  });
}

export async function addPendingEntry(entry) {
  await tx("pending_entries", "readwrite", (s) => s.put(entry));
}
export async function listPendingEntries() {
  return tx("pending_entries", "readonly", (s) => {
    return new Promise((resolve) => {
      const req = s.getAll();
      req.onsuccess = () => resolve(req.result || []);
    });
  });
}
export async function removePendingEntry(id) {
  await tx("pending_entries", "readwrite", (s) => s.delete(id));
}
export async function addPendingObservation(item) {
  await tx("pending_observations", "readwrite", (s) => s.put(item));
}
export async function listPendingObservations() {
  return tx("pending_observations", "readonly", (s) => {
    return new Promise((resolve) => {
      const req = s.getAll();
      req.onsuccess = () => resolve(req.result || []);
    });
  });
}
export async function removePendingObservation(id) {
  await tx("pending_observations", "readwrite", (s) => s.delete(id));
}
export async function addPendingPhoto(item) {
  await tx("pending_photos", "readwrite", (s) => s.put(item));
}
export async function listPendingPhotos() {
  return tx("pending_photos", "readonly", (s) => {
    return new Promise((resolve) => {
      const req = s.getAll();
      req.onsuccess = () => resolve(req.result || []);
    });
  });
}
export async function removePendingPhoto(id) {
  await tx("pending_photos", "readwrite", (s) => s.delete(id));
}
export async function addPendingFormScan(item) {
  await tx("pending_form_scans", "readwrite", (s) => s.put(item));
}
export async function listPendingFormScans() {
  return tx("pending_form_scans", "readonly", (s) => {
    return new Promise((resolve) => {
      const req = s.getAll();
      req.onsuccess = () => resolve(req.result || []);
    });
  });
}
export async function removePendingFormScan(id) {
  await tx("pending_form_scans", "readwrite", (s) => s.delete(id));
}
export async function addPendingIrrigationLog(item) {
  await tx("pending_irrigation_logs", "readwrite", (s) => s.put(item));
}
export async function listPendingIrrigationLogs() {
  return tx("pending_irrigation_logs", "readonly", (s) => {
    return new Promise((resolve) => {
      const req = s.getAll();
      req.onsuccess = () => resolve(req.result || []);
    });
  });
}
export async function removePendingIrrigationLog(id) {
  await tx("pending_irrigation_logs", "readwrite", (s) => s.delete(id));
}
export async function setCache(key, value) {
  await tx("cache", "readwrite", (s) => s.put({ id: key, value }));
}
export async function getCache(key) {
  return tx("cache", "readonly", (s) => {
    return new Promise((resolve) => {
      const req = s.get(key);
      req.onsuccess = () => resolve(req.result?.value);
    });
  });
}
